import { Switch } from 'react-router-dom';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';

import ElinxCollectContainer from './ElinxCollectContainer';
import ElinxConnectContainer from './ElinxConnectContainer';
import ElinxPayContainer from './ElinxPayContainer';
import ElinxFlexContainer from './ElinxFlexContainer';
import ElinxHistory from '../ElinxHistory/ElinxHistory';
import ElinxDetailsPage from '../ElinxHistory/Details/ElinxDetailsPage';
import ElinxConfirmationPage from '../ElinxHistory/Confirmation/ElinxConfirmationPage';
import ProtectedRoute from '../../../utils/ProtectedRoute';
import { useLockedFeatures } from '../../../providers/LockedFeatures.provider';

const Routes: React.FC = () => {
  const featureFlags = useModuleFeatureFlag('eLinx');
  const lockedFeatures = useLockedFeatures();

  return (
    <Switch>
      <ProtectedRoute
        isAllowed={!!lockedFeatures.PayLinkEnabled && featureFlags.isEnabled && !!lockedFeatures.CollectionsEnabled}
        showPermission
        exact
        path="/elinx/collect"
        component={ElinxCollectContainer}
      />
      <ProtectedRoute
        isAllowed={!!lockedFeatures.PayLinkEnabled && featureFlags.isEnabled && !!lockedFeatures.PaymentsEnabled}
        showPermission
        exact
        path="/elinx/pay"
        component={ElinxPayContainer}
      />
      <ProtectedRoute
        isAllowed={!!lockedFeatures.PayLinkEnabled && featureFlags.isEnabled}
        showPermission
        exact
        path="/elinx/connect"
        component={ElinxConnectContainer}
      />
      <ProtectedRoute
        isAllowed={!!lockedFeatures.PayLinkEnabled && featureFlags.isEnabled && !!lockedFeatures.CollectionsEnabled}
        showPermission
        exact
        path="/elinx/flex"
        component={ElinxFlexContainer}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.ViewPaylinkHitory}
        showPermission
        exact
        path="/elinx-history"
        component={ElinxHistory}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.ViewPaylinkHitory}
        showPermission
        exact
        path="/elinx-history/details/:ELinxId"
        component={ElinxDetailsPage}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.ViewPaylinkHitory}
        showPermission
        exact
        path="/elinx-history/:type/confirmation/:eLinxId/:notificationMethod/:eFlexOption"
        component={ElinxConfirmationPage}
      />
    </Switch>
  );
};

export default Routes;
